import './App.css';
import { Typography, Container, Box } from '@mui/material';
import { param_data } from './data';
import ParamSizeSection from './Param';
import HighQualitySamples from './HighQualitySamples'; // Import new component

export const ContainerStyle = {
  width: "100%",
  textAlign: "left",
  paddingLeft: "5vw",
  paddingRight: "5vw",
  height: "auto",
  marginTop: "10px",
};

function App() {
  return (
    <Container sx={{ paddingLeft: "5vw", paddingRight: "5vw", marginTop: "10px" }}>
      <Typography marginTop="8px" variant="h4" component="h4" fontStyle={"italic"}>
        Attention Variant Experiment
      </Typography>
      <hr />
      <Typography sx={{ marginBottom: '20px' }} variant="h6" component="h6" paddingTop="20px">
        * All of the samples below consist of a 4-bar prompt provided to the models, followed by 
        the models' generated continuations. First, a few select high-quality samples are shown, 
        followed by samples categorized by model size and attention mechanisms.
      </Typography>
      <Box marginTop="30px">
        <Typography sx={{ fontWeight: 'bold' }} marginTop="8px" variant="h5" component="h5" paddingBottom="12px">
          Highest Quality Samples
        </Typography>
        <hr />
        <HighQualitySamples /> {/* Render the new component */}
      </Box>
      <Typography sx={{ fontWeight: 'bold', marginBottom: '20px' }} marginTop="30px" variant="h5" component="h5">
        Model Generated Samples
      </Typography>
      <hr />

      {param_data.map((param, index) => (
        <ParamSizeSection key={index} paramSize={param.size} data={param.data} />
      ))}
    </Container>
  );
}

export default App;
